import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Input as ChakraInput, InputGroup, InputLeftAddon, InputLeftElement, InputRightElement } from '@chakra-ui/react';
import React from 'react';
import IconLabel from '../icon-label/iconlabel';
import { InfoOutlineIcon } from '@chakra-ui/icons';
import { SearchIcon } from '@chakra-ui/icons';
import { InputSize, InputVariant } from '../../core/enums';
export const Input = ({ addonLeft, classes, color, dataTestId, iconLeft, iconRight, label, textError, type, value, isDisabled = false, isError = false, isReadOnly = false, isRequired = false, placeholder = '', size = InputSize.MD, textInfo = '', variant = InputVariant.TEXT, ...props })=>{
    const effectiveIconLeft = iconLeft ?? (variant === InputVariant.SEARCH ? /*#__PURE__*/ _jsx(SearchIcon, {}) : undefined);
    return /*#__PURE__*/ _jsxs(FormControl, {
        sx: classes && classes.root,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isError,
        isReadOnly: isReadOnly,
        "data-testid": dataTestId?.trim() ?? 'input-field',
        children: [
            label && /*#__PURE__*/ _jsx(FormLabel, {
                sx: classes?.formLabel,
                children: label
            }),
            /*#__PURE__*/ _jsxs(InputGroup, {
                size: size,
                variant: variant,
                children: [
                    addonLeft && /*#__PURE__*/ _jsx(InputLeftAddon, {
                        role: "addonLeft",
                        children: addonLeft
                    }),
                    effectiveIconLeft && /*#__PURE__*/ _jsx(InputLeftElement, {
                        role: "iconLeft",
                        sx: classes?.leftIcon,
                        children: effectiveIconLeft
                    }),
                    /*#__PURE__*/ _jsx(ChakraInput, {
                        ...props,
                        value: value,
                        sx: classes?.input,
                        placeholder: placeholder,
                        type: type,
                        color: color,
                        isInvalid: isError,
                        isReadOnly: isReadOnly,
                        isDisabled: isDisabled
                    }),
                    iconRight && /*#__PURE__*/ _jsx(InputRightElement, {
                        role: "iconRight",
                        sx: classes?.rightIcon,
                        children: iconRight
                    })
                ]
            }),
            textInfo && /*#__PURE__*/ _jsx(FormHelperText, {
                children: /*#__PURE__*/ _jsx(IconLabel, {
                    isLeft: true,
                    leftIcon: /*#__PURE__*/ _jsx(InfoOutlineIcon, {
                        role: "infoIcon"
                    }),
                    label: textInfo
                })
            }),
            textError && /*#__PURE__*/ _jsx(FormErrorMessage, {
                children: /*#__PURE__*/ _jsx(IconLabel, {
                    isLeft: true,
                    leftIcon: /*#__PURE__*/ _jsx(InfoOutlineIcon, {
                        role: "errorIcon"
                    }),
                    label: textError
                })
            })
        ]
    });
};
Input.displayName = 'Input';
export default Input;
